const innerFontStore = [
  {
    fontFamily: 'THSJinRongTi-Medium',
    fontURL:
      'https://s.thsi.cn/cd/ths-frontend-common-lib-container/v1.3.6/common/font/THSJinRongTi-Medium.otf'
  },
  {
    fontFamily: 'THSJinRongTi-Regular',
    fontURL:
      'https://s.thsi.cn/cd/ths-frontend-common-lib-container/v1.3.6/common/font/THSJinRongTi-Regular.otf'
  }
];

function checkFontDefined(fontName: string) {
  // 检查字体是否已定义
  const fontFaceSet = document.fonts;
  let isFontDefined = false;

  fontFaceSet.forEach(font => {
    if (font.family === fontName) {
      isFontDefined = true;
    }
  });

  return isFontDefined;
}

// 定义并加载组件库需要的字体
function loadFont(fontName: string, fontURL: string) {
  const font = new FontFace(fontName, `url(${fontURL})`);

  font
    .load()
    .then(function (loadedFont) {
      document.fonts.add(loadedFont);
      console.log(`${fontName} 字体已在standardchart内部加载`);
    })
    .catch(function (error) {
      console.error(`standardchart内部加载字体失败: ${error}`);
    });
}

function registerFont() {
  innerFontStore.forEach(({ fontFamily, fontURL }) => {
    if (checkFontDefined(fontFamily)) {
      return;
    }
    loadFont(fontFamily, fontURL);
  });
}

registerFont();
